<template>
  <FilterCredit v-if="modalShowFilterTransaction" @closeModal="closeModal" @submitFilter="submitFilter" />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Riwayat Bon" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <div id="table-header" class="mb-5 flex justify-between items-end">
          <div class="mb-5 flex justify-between">
            <AddButton to_url="#" button_text="Filter" button_class="text-base py-2 font-medium" @click="showModal" />
          </div>
        </div>
        <div v-if="isLoading" class="flex justify-center items-center py-4">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
        <div v-else class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Pelunasan</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Kode</TableHeadCell>
                    <TableHeadCell>Nama Pelanggan</TableHeadCell>
                    <!-- <TableHeadCell>Order Type</TableHeadCell> -->
                    <TableHeadCell>Staff</TableHeadCell>
                    <TableHeadCell>Metode pembayaran</TableHeadCell>
                    <TableHeadCell>Sub Total</TableHeadCell>
                    <TableHeadCell>tax</TableHeadCell>
                    <TableHeadCell>Service Charge</TableHeadCell>
                    <TableHeadCell>Diskon</TableHeadCell>
                    <TableHeadCell>Grand Total</TableHeadCell>
                    <TableHeadCell>Keterangan</TableHeadCell>
                    <TableHeadCell>Bayar</TableHeadCell>
                    <TableHeadCell>Waktu Transaksi</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Cash Register</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allSalesOrders.length == 0">
                    <TableCell colspan="18" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-for="(transaction, index) in allSalesOrders" :key="transaction.id">
                    <TableCell>
                      {{ (index + 1) + ((Number(currentPage) - 1) * Number(perPage)) }}
                    </TableCell>
                    <TableCell>
                      <button v-if="!transaction.is_paid_off"
                        class="bg-success hover:bg-hover-success flex justify-center items-center mx-1 p-2 rounded-md group text-white"
                        @click="paidOff(transaction)">Lunaskan</button>
                    </TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-success dark:bg-success text-white': transaction.is_paid_off,
                        'bg-danger dark:bg-danger text-white': !transaction.is_paid_off
                      }" class="px-2 py-1 rounded-full text-xs font-medium">
                        {{ transaction.is_paid_off ? "LUNAS" : "BELUM LUNAS" }}
                      </span>
                    </TableCell>
                    <TableCell>
                      {{ transaction.code }}
                    </TableCell>
                    <TableCell>
                      {{ transaction.customer_name }}
                    </TableCell>
                    <!-- <TableCell>
                      {{ transaction.order_type }}
                    </TableCell> -->
                    <TableCell>
                      {{this.allMarketings?.find(m => m.id == transaction.marketing_id)?.name}}
                    </TableCell>
                    <TableCell>
                      {{formatPaymentMethodeName(transaction.payment_method_id)}}
                    </TableCell>
                    <TableCell>
                      {{ transaction.sub_total }}
                    </TableCell>
                    <TableCell>
                      {{ transaction.tax }}
                    </TableCell>
                    <TableCell>
                      {{ transaction.service_charge }}
                    </TableCell>
                    <TableCell>
                      {{ transaction.discount }}
                    </TableCell>
                    <TableCell>
                      {{ transaction.grand_total }}
                    </TableCell>
                    <TableCell>
                      {{ transaction.note }}
                    </TableCell>
                    <TableCell>
                      {{ transaction.payment_amount }}
                    </TableCell>
                    <TableCell>
                      {{ formatDate(transaction.createdAt) }}
                    </TableCell>
                    <TableCell>
                      <div>
                        {{ transaction.status }}
                      </div>
                      <div v-if="transaction.status === 'paid'">
                        {{ formatDate(transaction.updatedAt) }}
                      </div>
                    </TableCell>
                    <TableCell>
                      {{ formatDate(transaction.cash_register.time_start) }}
                    </TableCell>
                    <TableCell>
                      <div class="flex">
                        <RouterLink :to="{ path: '/order', query: { orderId: transaction.id } }"
                          class="bg-warning hover:bg-hover-warning flex justify-center items-center mx-1 p-2 rounded-md group">
                          <ShoppingCartIcon class="h-4 w-4 text-light-900 group-hover:text-primary" />
                        </RouterLink>
                        <RouterLink :to="{ path: '/payment', query: { orderId: transaction.id } }"
                          class="bg-info hover:bg-hover-info flex justify-center items-center mx-1 p-2 rounded-md group">
                          <EyeIcon class="h-4 w-4 text-white group-hover:text-white" />
                        </RouterLink>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" v-model:perPage="perPage" :withPerPage="true" :totalRecords="totalRecords" />
            </div>
          </div>
        </div>
        <Accordion value="0">
          <AccordionPanel value="0">
            <AccordionHeader>Ringkasan Bon</AccordionHeader>
            <AccordionContent class="bg-white dark:bg-dark-800">
              <div class="bg-white dark:bg-dark-800 p-4 rounded-lg shadow">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                    <p class="text-sm text-gray-500 dark:text-gray-400">Total Transaksi</p>
                    <p class="text-xl font-semibold text-gray-900 dark:text-white">{{ allSalesOrders.length }}</p>
                  </div>
                  <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                    <p class="text-sm text-gray-500 dark:text-gray-400">Total Bon</p>
                    <p class="text-xl font-semibold text-gray-900 dark:text-white">{{ formatRupiah(totalCredit) }}</p>
                  </div>
                  <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                    <p class="text-sm text-gray-500 dark:text-gray-400">Total Belum Terbayar</p>
                    <p class="text-xl font-semibold text-gray-900 dark:text-white">{{ formatRupiah(totalNotPaidOff) }}</p>
                  </div>
                  <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                    <p class="text-sm text-gray-500 dark:text-gray-400">Total Sudah Terbayar</p>
                    <p class="text-xl font-semibold text-gray-900 dark:text-white">{{ formatRupiah(totalPaidOff) }}</p>
                  </div>
                </div>
              </div>
            </AccordionContent>
          </AccordionPanel>
        </Accordion>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import IndexView from "@/views/IndexView.vue";
import { EyeIcon, ShoppingCartIcon } from "@heroicons/vue/24/solid";
import AddButton from "@/components/buttons/AddButton.vue";
import { mapActions, mapGetters } from "vuex";
import PaginationButtons from "@/components/PaginationButtons.vue";
import { TableComponent } from "@/components/table";
import TableHead from "@/components/table/TableHead.vue";
import TableBody from "@/components/table/TableBody.vue";
import TableRow from "@/components/table/TableRow.vue";
import TableCell from "@/components/table/TableCell.vue";
import TableHeadCell from "@/components/table/TableHeadCell.vue";
import FilterCredit from "./modals/FilterCredit.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import { Accordion, AccordionPanel, AccordionContent, AccordionHeader, Button, ConfirmDialog } from "primevue";
import { formatRupiah } from "@/helpers/formatRupiah";
import { paymentMethode } from "@/helpers/constanta";

export default {
  name: "CreditView",
  components: {
    PageTitle,
    IndexView,
    ShoppingCartIcon,
    AddButton,
    EyeIcon,
    PaginationButtons,
    TableComponent,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableHeadCell,
    Button,
    ConfirmDialog,
    FilterCredit,
    ViewContainer,
    Accordion,
    AccordionPanel,
    AccordionContent,
    AccordionHeader,
  },
  data() {
    return {
      paymentMethode,
      modalShowFilterTransaction: false,
      isBlur: false,
      listTransaction: [],
      socket: null,
      message: "",
      messages: [],
      isLoading: false,
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      filter: {},
      totalRecords: 0,
    };
  },
  async created() {
    this.fetchSalesOrders();
    this.fetchAdditionalData();
  },
  computed: {
    ...mapGetters('sales_orders', ['allSalesOrders']),
    ...mapGetters('tables', ['allTables']),
    ...mapGetters('marketings', ['allMarketings']),
    ...mapGetters('payment_methods', ['allPaymentMethods']),
    totalCredit() {
      return this.allSalesOrders.reduce((total, credit) => total + Number(credit.grand_total), 0);
    },
    totalPaidOff() {
      return this.allSalesOrders.filter(credit => credit.is_paid_off).reduce((total, credit) => total + Number(credit.grand_total), 0);
    },
    totalNotPaidOff() {
      return this.allSalesOrders.filter(credit => !credit.is_paid_off).reduce((total, credit) => total + Number(credit.grand_total), 0);
    },
    totalPax() {
      return this.allSalesOrders.reduce((total, credit) => total + credit.pax, 0);
    },
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        const filteredFilter = Object.entries(this.filter).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            if (key === 'rangeDate') {
              const start_date = this.formateISODate(this.filter.rangeDate[0]);
              const end_date = this.formateISODate(this.filter.rangeDate[1]);
              acc.start_date = start_date;
              acc.end_date = end_date;
              acc.date_column = 'createdAt';
            } else {
              acc[key] = value;
            }
          }
          return acc;
        }, {});
        this.fetchSalesOrders({ page: newVal, ...filteredFilter, limit: this.perPage });
      },
    },
    perPage: {
      immediate: true,
      handler(newVal) {
        const filteredFilter = Object.entries(this.filter).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            if (key === 'rangeDate') {
              const start_date = this.formateISODate(this.filter.rangeDate[0]);
              const end_date = this.formateISODate(this.filter.rangeDate[1]);
              acc.start_date = start_date;
              acc.end_date = end_date;
              acc.date_column = 'createdAt';
            } else {
              acc[key] = value;
            }
          }
          return acc;
        }, {});
        this.fetchSalesOrders({ page: 1, ...filteredFilter, limit: newVal });
      },
    },
  },
  methods: {
    ...mapActions('sales_orders', ['updateSalesOrder']),
    formatRupiah,
    formatPaymentMethodeName(paymentMethodId) {
      const paymentMethod = this.allPaymentMethods.find(paymentMethod => paymentMethod.id === paymentMethodId);
      return paymentMethode?.[paymentMethod?.name?.toUpperCase()] || paymentMethod?.name || '-';
    },
    formatDate(date) {
      console.log(date);
      if (!date) return "-";
      const d = new Date(date);
      const pad = (num) => num.toString().padStart(2, "0");

      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = d.getFullYear().toString().slice(-2);
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    formateISODate(date) {
      const localDate = new Date(date);
      const offset = localDate.getTimezoneOffset();
      const adjustedDate = new Date(localDate.getTime() - (offset * 60 * 1000));
      return adjustedDate.toISOString().split('T')[0];
    },
    async fetchSalesOrders(params = {}) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = this.perPage;
      params.is_credit = true;
      try {
        const { pagination } = await this.$store.dispatch('sales_orders/fetchSalesOrders', params);
        if (pagination) {
          this.totalPages = Number(pagination.totalPages);
          this.currentPage = Number(pagination.page);
          this.perPage = Number(pagination.perPage);
          this.totalRecords = Number(pagination.totalItems);
        } else {
          this.totalPages = 1;
          this.currentPage = 1;
          this.perPage = 50;
          this.totalRecords = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAdditionalData() {
      this.$store.dispatch('tables/fetchTables', { limit: 1000 });
      this.$store.dispatch('marketings/fetchMarketings', { limit: 1000 });
      this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
    },
    showModal() {
      this.modalShowFilterTransaction = true;
      this.isBlur = true;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowFilterTransaction = false;
        this.isBlur = false;
      }, 200);
    },
    async submitFilter(filter) {
      this.filter = filter;
      let params = {};

      if (this.filter.capacity) {
        params.capacity = this.filter.capacity;
      }

      if (this.filter.type) {
        params.order_type = this.filter.type;
      }

      if (this.filter.status) {
        params.status = this.filter.status;
      }

      if (this.filter.marketing_id) {
        params.marketing_id = this.filter.marketing_id;
      }

      if (this.filter.payment_method_id) {
        params.payment_method_id = this.filter.payment_method_id;
      }

      if (this.filter.table_id) {
        params.table_id = this.filter.table_id;
      }

      if (this.filter.cash_register_id) {
        params.cash_register_id = this.filter.cash_register_id;
      }

      if (this.filter.customer_name) {
        params.customer_name = this.filter.customer_name;
      }

      if (this.filter.rangeDate) {
        const start_date = this.formateISODate(this.filter.rangeDate[0]);
        const end_date = this.formateISODate(this.filter.rangeDate[1]);
        params.start_date = start_date;
        params.end_date = end_date;
        params.date_column = 'createdAt';
      }

      await this.fetchSalesOrders(params);
      await this.updateFilter(filter);
    },
    updateFilter(filter) {
      this.filter = filter;
    },
    paidOff(transaction) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah tagihan ini sudah lunas?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            await this.updateSalesOrder({ id: transaction.id, is_paid_off: true, transaction_type_id: transaction.transaction_type_id, order_type: transaction.order_type, table_id: transaction.table_id, });
            this.fetchSalesOrders();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil melunaskan tagihan.', life: 3000 });
          }
          catch (error) {
            console.error('Gagal melunaskan tagihan.', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal melunaskan tagihan.', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal melunaskan tagihan.', life: 3000 });
        }
      });
    },
  },
};
</script>
